export const HemisphereLights = ({ lights }) =>
  lights.map(({ skyColor, groundColor, intensity }, index) => (
    <hemisphereLight
      color={skyColor}
      groundColor={groundColor}
      intensity={intensity}
      key={index}
    />
  ));
